<h4 class="di-header">{{ "Purchase Includes" | translate }}</h4>
<div class="di-content" [innerHTML]="purchaseIncludesMarkup | safeHtml"></div>
<h4 class="di-header" *ngIf="hasPackageDetails">{{ "Package Details" | translate }}</h4>
<div class="di-content" *ngIf="hasPackageDetails" [innerHTML]="packageDetailsMarkup | safeHtml"></div>
<h4 class="di-header" *ngIf="hasAbout">{{ "About" | translate }}</h4>
<div class="di-content" *ngIf="hasAbout" [innerHTML]="aboutMarkup | safeHtml"></div>

